var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container home-content"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"navbars"},[_c('NavBars')],1),_c('div',[_c('MiddleOfHome')],1),_c('div',{staticClass:"popular"},[_c('Popular')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }